// extracted by mini-css-extract-plugin
export default {"wrapper":"BreadCrumbs_wrapper__iXCcU","separator":"BreadCrumbs_separator__MTT3z"};